import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories, getArticlesByCategory } from '@/mocks/gossip';

export default function CategorySection() {
  return (
    <section className="mt-16 bg-background-100 py-16 md:mt-20 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8">
        <SectionHeading
          eyebrow="主题分类"
          title="四个入口，快速抵达想看的内容"
          description="无论你是想找清晰生图、红毯造型，还是两人同框的名场面，都能一步到位。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((category) => {
            const count = getArticlesByCategory(category.slug).length;
            return (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative h-40 w-full overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.alt}
                    title={`${category.name} - 诱惑吃瓜`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/95 text-lg text-primary-600">
                    <i className={category.icon} aria-hidden="true"></i>
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {category.name}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {category.intro}
                  </p>
                  <span className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    已收录 {count} 篇深度内容
                    <i className="ri-arrow-right-up-line text-base text-primary-500" aria-hidden="true"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}